/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useCallback, useState } from 'react';
import SimpleBar from 'simplebar-react';
import { withTranslation } from 'react-i18next';
import MetisMenu from 'metismenujs';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { InnoboIcon } from '../../components/Common/Icon/InnoboIcon';
import { changeTitleBanner } from '../../store/actions';
import { useDispatch } from 'react-redux';
import FooterCopyright from './FooterCopyright';

const SidebarContent = (props: any) => {
    const ref = useRef<any>();
    const dispatch = useDispatch();
    const permissions = JSON.parse(props.d);
    const [itemState, setItemState] = useState(permissions);
    const childArray: any = [];

    const activateParentDropdown = useCallback((item: any) => {
        item.classList.add('active');

        const parent = item.parentElement;
        const parent2El = parent.childNodes[1];
        if (parent2El && parent2El.id !== 'side-menu') {
            parent2El.classList.add('mm-show');
        }

        if (parent) {
            parent.classList.add('mm-active');
            const parent2 = parent.parentElement;
            if (parent2) {
                parent2.classList.add('mm-show'); // ul tag
                const parent3 = parent2.parentElement; // li tag
                if (parent3) {
                    parent3.classList.add('mm-active'); // li
                    parent3.childNodes[0].classList.add('mm-active'); //a
                    const parent4 = parent3.parentElement; // ul
                    if (parent4) {
                        parent4.classList.add('mm-show'); // ul
                        const parent5 = parent4.parentElement;
                        if (parent5) {
                            parent5.classList.add('mm-show'); // li
                            parent5.childNodes[0].classList.add('mm-active'); // a tag
                        }
                    }
                }
            }
            scrollElement(item);
            return false;
        }
        scrollElement(item);
        return false;
    }, []);

    useEffect(() => {
        const pathName = props.location.pathname;
        const initMenu = () => {
            const permisos = localStorage.getItem('permisos') || '';
            let permisosObjArr = JSON.parse(permisos);
            permisosObjArr = permisosObjArr.map((item: any) => {
                if (item.identificator === "Holistics") item.url_menu = "/GenericHollistics/" + item.id
                if (item.identificator === "iFrame") item.url_menu = "/Iframe/" + item.id
                return { ...item }
            })
            setItemState(permisosObjArr);

            new MetisMenu('#side-menu');
            let matchingMenuItem = null;
            const ul: any = document.getElementById('side-menu');
            const items = ul.getElementsByTagName('a');
            for (let i = 0; i < items.length; ++i) {
                if (pathName === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        initMenu();
    }, [activateParentDropdown]);

    useEffect(() => {
        ref.current.recalculate();
    });

    function scrollElement(item: any) {
        if (item) {
            const currentPosition = item.offsetTop;
            if (currentPosition > window.innerHeight) {
                ref.current.getScrollElement().scrollTop = currentPosition - 300;
            }
        }
    }

    const filter = (array: any) => {
        array.filter((val: any) => {
            if (val.padreId !== null) {
                childArray.push(val);
            }
            if (val.url_menu === '#') {
                val.isVisible = false;
            }
        });
    };
    filter(permissions);

    const getChildren = (padreId: any, newArray: any) => {
        if (padreId) {
            const childrenArray = itemState.filter((item: any) => item.padreId === padreId);
            return childrenArray.map((child: any) => {
                newArray.push(child.id);
                getChildren(child.id, newArray)
            });
        }
    };

    const handlerLinkOpen = (e: any, item: any, action: number) => {
        if (action !== 2) e.preventDefault();
        const sideBarStatus = document.body.getAttribute('data-sidebar-size');

        if (sideBarStatus !== 'sm' || action !== 0) {
            const newArray: any = [];
            if (sideBarStatus === 'sm') getChildren(item.id, newArray);
            const newState = itemState.map((obj: any) => {

                const rect = e.currentTarget.getBoundingClientRect();
                if (obj.id === item.id) {
                    obj.Bounding = rect.top + window.scrollY - 70;
                    obj.isVisible = !item.isVisible;
                }
                if (sideBarStatus === 'sm') {
                    obj.isVisible = false;
                    if (obj.id === item.id) obj.isVisible = !item.isVisible;
                    if (obj.id === item.id || newArray.includes(obj.id)) obj.isVisible = true;
                }

                return obj;
            });
            setItemState(newState);
            localStorage.setItem('permisos', JSON.stringify(itemState));
        }
    };

    const handlerOnclick = ({ e, item, action, type }: any) => {
        if (type === "both" || type === "menu") handlerLinkOpen(e, item, action)

        if (type === "both" || type === "permission") {
            if (item.url_menu === "/home") dispatch(changeTitleBanner(""))

            item.selected = true;
            const newState = itemState.map((obj: any) => {
                if (obj.id === item.id) {
                    obj.selected = true;
                } else if (obj.url_menu != '#') {
                    obj.selected = false;
                }
                return obj;
            });
            setItemState(newState);
            localStorage.setItem('permisos', JSON.stringify(itemState));
        }
    }

    const RenderButtonsMenu = React.memo(({ array, type }: any) => {
        return array.map((item: any, key: any) => {
            const children = itemState.filter((childItem: any) => childItem.padreId === item.id);
            const isChild = type === "Child";
            const isPadre = children.length > 0;
            type = isPadre && isChild ? "PadreChild" : type;
            const isMenuPrimary = item.url_menu === '#' && item.padreId === null;
            const isMenuSecundary = item.url_menu === '#' && item.padreId !== null;
            const ispermissionPrimary = item.url_menu !== '#' && item.padreId === null;
            const ispermissionSecundary = item.url_menu !== '#' && item.padreId !== null;
            const isIframeMenu = item.identificator === "iFrame" && isPadre;
            if (item?.nombre?.length > 26) item.nombre = item?.nombre?.substring(0, 26);
            return (
                <React.Fragment key={key}>
                    {((isMenuPrimary) || (ispermissionPrimary) && type === "NonPadre")
                        || (isMenuSecundary && type === "PadreChild")
                        || ((ispermissionSecundary && isChild) || (ispermissionSecundary && type === "PadreChild"))
                        ? (
                            <li
                                className={item.isVisible && isPadre ? 'mm-active' : ""}>
                                <Link
                                    title={item.nombre}
                                    id={item.id}
                                    to={{ pathname: item.url_menu }}
                                    className={
                                        isMenuPrimary
                                            || isMenuSecundary
                                            || isIframeMenu
                                            ? `has-arrow ${isIframeMenu && item.selected ? "activeChild" : ""}`
                                            : `d-flex ${item.selected ? 'activeChild' : ''} ${item?.nombre?.length >= 19 ? "OverSizeTextMenu" : ""}  text-nowrap`}
                                    onClick={(e) => {
                                        if (isMenuPrimary || isMenuSecundary) {
                                            handlerOnclick({ type: "menu", e, item, action: isMenuPrimary ? 1 : 0 })
                                        } else if (isIframeMenu) {
                                            handlerOnclick({ type: "both", e, item, action: 2 })
                                        } else {
                                            handlerOnclick({ type: "permission", e, item })
                                        }
                                    }}
                                >
                                    <InnoboIcon name={item.icon} />
                                    <span>{item.nombre}</span>
                                </Link>
                                {(isMenuPrimary || isMenuSecundary || isIframeMenu) && item.isVisible && isPadre &&
                                    <ul className="sub-menu" >
                                        <RenderButtonsMenu
                                            array={children}
                                            type="Child"
                                        />
                                    </ul>
                                }
                            </li>
                        ) : null
                    }
                </React.Fragment >
            );
        });
    });

    return (
        <React.Fragment>
            <SimpleBar style={{ maxHeight: '100%' }} ref={ref} >
                <div id="sidebar-menu" >
                    <ul className="metismenu list-unstyled" id="side-menu" >
                        <li className="menu-title" > {props.t('Menu')} </li>

                        <RenderButtonsMenu
                            array={itemState}
                            type="NonPadre"
                        />

                    </ul>
                </div>
            </SimpleBar>
            <div className='containerFooterSidebar'>
                <FooterCopyright />
            </div>
        </React.Fragment>
    );
};

SidebarContent.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(withRouter(SidebarContent));
